let recordComponent: ReturnType<typeof importRecordComponent> | undefined;

function importRecordComponent() {
  return import('./record.component');
}

export function loadRecordComponent() {
  recordComponent ??= importRecordComponent();
  return recordComponent;
}

export function preloadRecordComponent(): void {
  void loadRecordComponent();
}
